/**
 * Onglet humoristique "Planning wc".
 * Affiche la photo culte de la cuvette aux deux rouleaux PQ en guise d'yeux,
 * surmontée du titre "C'EST OCCUPÉ !".
 *
 * La photo doit être déposée dans frontend/public/wc-occupe.jpg
 * (servie à la racine en prod : https://hossegor.bellenger.me/wc-occupe.jpg).
 */
export default function PlanningWc() {
  return (
    <div className="space-y-4">
      <section className="card p-4 sm:p-6 text-center">
        <h2 className="text-3xl sm:text-5xl font-display font-extrabold text-coral-600 tracking-tight drop-shadow-sm">
          C'EST OCCUPÉ !
        </h2>
      </section>

      <section className="card overflow-hidden">
        <figure className="relative bg-sand-50">
          <img
            src="/wc-occupe.jpg"
            alt="Photo humoristique : cuvette de toilettes avec deux rouleaux de papier WC formant des yeux étonnés"
            className="w-full max-h-[78vh] object-contain mx-auto block"
            loading="eager"
          />
        </figure>
      </section>
    </div>
  )
}
